import { render, staticRenderFns } from "./VolleyballCover_c2.vue?vue&type=template&id=cf94df78&"
import script from "./VolleyballCover_c2.vue?vue&type=script&lang=js&"
export * from "./VolleyballCover_c2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports